// @flow
import React from 'react';
import classnames from 'classnames';
import { translate, type TFunction } from 'react-i18next';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import {
    PopoverTriggerEnum,
    PopoverPlaceEnum
} from 'common/components/core/popover/popOverFactory';
import { GanttTypeEnum } from 'common/enums/LiveViewEnums';
import theme from './GanttLabel.scss';

type Props = {
    t: TFunction,
    tourColor: string,
    ganttType: string
};

const GanttLabel = ({ t, ganttType, tourColor }: Props) => {
    const popOverContent =
        ganttType === GanttTypeEnum.Planned
            ? t('plannedRoute')
            : t('executedRoute');
    return (
        <DivWithPopover
            className={theme.ganttLabel}
            triggerPopoverOn={PopoverTriggerEnum.Hover}
            popOverContent={popOverContent}
            preferPlace={PopoverPlaceEnum.Right}
        >
            <div
                className={classnames(theme.solidLine, {
                    [theme[tourColor]]: ganttType !== GanttTypeEnum.Planned
                })}
            />
            <span>{t(ganttType)}</span>
        </DivWithPopover>
    );
};

export default translate('liveView')(GanttLabel);
